<template>
  <wrapper>
    <template slot="navigation">
      <menu-point icon="chevron-left" to="dashboard">Zurück</menu-point>
      <menu-point to="settlement.settlements">Abrechnungen</menu-point>
      <menu-point to="settlement.invoices">Rechnungen</menu-point>
    </template>

    <template slot="page">
      <router-view></router-view>
    </template>
  </wrapper>
</template>

<script>
import { MenuPoint, Wrapper } from "@/components/Wrapper";

export default {
  components: {
    MenuPoint,
    Wrapper,
  },
};
</script>
